/**
 * Score Card
 * 
 * This file contains a React component called CardScore that displays the team's final 
 * score with animations. It imports the getTeamTotalScore function from ../utils/team-data 
 * to calculate the total score. The component uses the CountUp component from the 
 * react-countup library to animate the score count. It also uses two SVG components 
 * called SvgFirework and SvgFireworksCenter to display fireworks animations. 
 * The component has two buttons, one to rate the hunt and another to skip it.
 * 
 * Shown on the Finish Page
 */

import React from 'react'
import CountUp from 'react-countup'
import { getTeamTotalScore } from '../utils/team-data'
import SvgFirework from './svg/firework'
import SvgFireworksCenter from './svg/fireworks-center'
import { playPendingHuntCompleteSound } from '../utils/play-sound'

export default class CardScore extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
    }
    this.handleRate = this.handleRate.bind(this)
    this.handleSkip = this.handleSkip.bind(this)
  }

  componentDidMount() {
    this.setState({ height: window.innerHeight })
  }

  handleRate() {
    playPendingHuntCompleteSound()
    this.props.nextFunc()
  }

  handleSkip() {
    playPendingHuntCompleteSound()
    this.props.skipFunc()
  }

  render() {
    const points = getTeamTotalScore()

    return (
      <>
        <div className="card full-height score-card">
          <div className="card-header text-center">
            <h3>You did it!</h3>
          </div>
          <div className="card-body text-center text-uppercase">
            <SvgFirework className={`firework firework-1`} />
            <p className="my-3">
              <span className={`d-block`}>You</span>
              <span>
                earned{` `}
                <strong className="points text-huge d-block my-3">
                  <SvgFireworksCenter className={`fireworks-center`} />
                  <CountUp end={points} />
                </strong>
                {` `}
                total
              </span>
              <span className={`d-block`}>Points!</span>
            </p>
            <SvgFirework className={`firework firework-2`} />
          </div>
          <div className="card-footer bg-transparent border-0">
            <button className={`btn btn-block btn-success text-uppercase mt-auto`} onClick={this.handleRate}>
              Rate your hunt
            </button>
            <button
              className="btn btn-link text-dark w-100 text-center mt-3 text-lowercase"
              onClick={this.handleSkip}>
              No thanks
            </button>
          </div>
        </div>
      </>
    )
  }
}
